import XIcon from './x';
import CheckIcon from './check';

export default function ValidIcon({ isValid = false }) {
    return (
        isValid ?
            <CheckIcon /> :
            <XIcon />
    )
}